import React from 'react';
import SidebarLayout from '../components/SidebarLayout';
import DashboardNavigation from '../components/DashboardNavigation';
import DashboardContent from '../components/DashboardContent';

/**
 * Main dashboard component with integrated navigation and content
 * Provides a unified interface for different dashboard modules
 */
const Dashboard: React.FC = () => {
  return (
    <SidebarLayout>
      <div className="h-full flex flex-col p-6">
        {/* Dashboard Navigation */}
        <DashboardNavigation />

        {/* Dashboard Content */}
        <div className="flex-1 overflow-y-auto">
          <DashboardContent />
        </div>
      </div>
    </SidebarLayout>
  );
};

export default Dashboard;
